import { getNodeIdComposer } from '@utils';
import { RootPrefix } from './constants';

export const authId = getNodeIdComposer(RootPrefix);
export const signInId = getNodeIdComposer(RootPrefix, 'sign_in');
export const signUpId = getNodeIdComposer(RootPrefix, 'sign_up');
export const twoFactorId = getNodeIdComposer(RootPrefix, 'two_factor');
export const passwordRecoveryId = getNodeIdComposer(RootPrefix, 'password_recovery');
export const passwordResetId = getNodeIdComposer(RootPrefix, 'password_reset');
export const otpId = getNodeIdComposer(RootPrefix, 'otp');
